import React, { useState } from "react";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import { axiosInstance } from "../../../utils/axiosInstance";
import { useDispatch } from "react-redux";
import { fetchProviders } from "../../../store/planProviders";
import Button from "../../common/Button";
import OpticalCarePlanTable from "../../uis/opticalCarePlanTable/approvedTable";
import ReusableOpticalCarePlanModal from "../../uis/modals/ReusableOpticalCarePlanModal";
import { fetchOpticalCarePlans } from "../../../store/opticalCarePlan";

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
const OpticalCarePlan = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    mode: null,
    providerData: null,
  });

  const dispatch = useDispatch();

  const handleCreatePlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.post(`/v1/admin/optical-care`, data);
      if (response.status) {
        dispatch(fetchOpticalCarePlans(10, 1)); // Refresh table
      }
    } catch (error) {
      console.error("Error creating Optical Care plan:", error);
      throw error; // Let modal handle error
    }
  };

  const handleEditPlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/optical-care/${id}`,
        data
      );
      console.log("Health Plan updated successfully:", response.data);
      dispatch(fetchProviders(10, 1)); // Refresh table
    } catch (error) {
      console.error("Error updating Optical Care plan:", error);
      throw error; // Let modal handle error
    }
  };

  const openModal = (mode, providerData) => {
    setModalConfig({
      isOpen: true,
      mode,
      providerData,
    });
  };

  const closeModal = () => {
    setModalConfig({ isOpen: false, mode: null, providerData: null });
  };

  return (
    <>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
        <Button onClick={() => openModal("create", {})}>
          {" "}
          Create Optical Care Plan
        </Button>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabPanelContainer}>
            <OpticalCarePlanTable
              openModal={openModal}
              closeModal={closeModal}
            />
          </div>
          <ReusableOpticalCarePlanModal
            isOpen={modalConfig.isOpen}
            onClose={closeModal}
            mode={modalConfig.mode}
            providerData={modalConfig.providerData}
            onSubmit={
              modalConfig.mode === "create"
                ? handleCreatePlanProvider
                : handleEditPlanProvider
            }
          />
        </div>
      </div>
    </>
  );
};

export default OpticalCarePlan;
